import { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFetch } from "@/lib/hooks";
import { Panel } from "@/components/core/AppLayout";
import { TaskTable } from "@/components/core/TaskTable";
import { TaskBoard } from "@/components/core/TaskBoard";
import { ViewToggle } from "@/components/core/ViewToggle";
import { TaskFormDialog } from "@/components/core/TaskFormDialog";

export const ClientTasks = ({ clientId, users }) => {
  const { data: tasks, reload } = useFetch(`/tasks?client_id=${clientId}`);
  const [open, setOpen] = useState(false);
  const [view, setView] = useState(() => localStorage.getItem("core_task_view") || "elenco");
  useEffect(() => localStorage.setItem("core_task_view", view), [view]);
  const open_n = (tasks || []).filter((t) => t.stato !== "completata").length;

  return (
    <div data-testid="client-tasks">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-4">
          <ViewToggle value={view} onChange={setView} testidPrefix="client-task-view" />
          <div className="text-sm text-slate-500"><span className="font-bold text-[#0A1128]">{open_n}</span> task aperte su {tasks?.length || 0}</div>
        </div>
        <Button onClick={() => setOpen(true)} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] font-bold" data-testid="client-add-task-button"><Plus className="h-4 w-4 mr-1" />Nuova task</Button>
      </div>
      {view === "bacheca" ? (
        <TaskBoard tasks={tasks} onChanged={reload} showClient={false} users={users} clientId={clientId} />
      ) : (
        <Panel className="overflow-hidden">
          <TaskTable tasks={tasks} onChanged={reload} showClient={false} users={users} clientId={clientId} emptyText="Crea la prima task per questo cliente." />
        </Panel>
      )}
      <TaskFormDialog open={open} onOpenChange={setOpen} clientId={clientId} users={users} onSaved={reload} />
    </div>
  );
};
